import WeatherAnnouncement from './WeatherAnnouncement/WeatherAnnouncement';
import S from './AnnouncementsStyles';

function Announcements():JSX.Element {
  return (
    <S.Wrapper>
      <WeatherAnnouncement />
    </S.Wrapper>
  );
}

export default Announcements;
